module.exports = __webpack_public_path__ + "static/media/corporate-thumbnail.cb86ace4.svg";